/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isJSSlot(data) {
  return data && data.type === 'JSSlot';
}